<template>
 <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md5 lg4>
             <img src="../../assets/images/unoapp.png" class="form-head-logo mb-2"/>
            <v-card class="elevation-12">
              <offset-heading  titleClass="mb-0 headline font-weight-bold" title="FORGOT PASSWORD" subtitle="Enter your email address and  we'll send you details"></offset-heading>
              <v-card-text class="nmt-20 px-5 mt-7 pt-7">
                <v-form v-if="!emailSent" ref="forgot-password">
                  <v-text-field
                  v-model="user.email"
                  :rules="emailRules"
                  prepend-icon="fas fa-user-circle"
                  required
                  validate-on-blur
                  name="E-mail"
                  label="E-mail"
                  type="text">
                  </v-text-field>
                </v-form>
                <p
                v-if="emailSent"
                class="subtitle is-6 mb-4">
                We will send further instructions to the email you provided,
                if it is linked to an account.</p>

                <div class="px-5">
                  <v-card-text
                    v-if="!emailSent"
                    role="button">
                    <router-link class="normal-link" :to="{ name: 'Login'}">Go back to login? </router-link>
                  </v-card-text>
                  <v-btn
                    v-if="!emailSent"
                    color="primary"
                    fab
                    medium
                    @click="forgot($event)"
                  >
                    <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
                  </v-btn>
                  <router-link :to="{ name: 'Login'}">
                    <v-btn
                      v-if="emailSent"
                      color="primary" >
                      Okay
                    </v-btn>
                  </router-link>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { mapActions } from 'vuex';
import NormalApi from '@/components/Controllers/NormalApi'; // Just naming as readable
import Helper from '@/components/Controllers/Helpers';
import Env from '@/env';

export default {
  name: 'LoginForgot',
  // data: () => ({
  data() {
    return {
      emailSent: false,
      user: {
        email: '',
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid',
      ],
    };
  },
  props: {
    source: String,
  },
  methods: {
    /**
     * Handles the forgot password email submisstion
     */
    forgot() {
      if (this.$refs['forgot-password'].validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/users/password/reset`;
        NormalApi.postApi(url,{
          'api-token': Env.apiToken 
        }, this.user)
          .then((res) => {
        
            this.spinner(false);
            this.emailSent = true;
            this.snackbar({
              text: res.data.msg, // Change text to readable and uppercase
              timeout: 3000,
              open: true,
            });
         
          })
          .catch((err) => {
            this.spinner(false);
            this.snackbar({
              text: 'Please try again later.',
              timeout: 3000,
              open: true,
            });
          });
      }
    },
    ...mapActions({
      snackbar: 'snackbar/snackbar',
      spinner: 'spinner/spinnerStatus',
    }),
  },
};
</script>

